unit GiftAidClaimForm;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  JobBaseForm,
  WEBLib.ExtCtrls,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.WebCtrls,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  WEBLib.StdCtrls,
  Vcl.Mask,
  WEBLib.Mask,
  WEBLib.CDS, DB,
  GA.Return.Types, Vcl.Imaging.GIFImg;


type
  TGiftAidClaimJob = class(TJobBase)
    AgreeCheckBox: TCheckBox;
    AuthorisedOfficial: TLookupComboBox;
    AuthOfficials: TXDataWebDataSet;
    AuthOfficialsId: TIntegerField;
    AuthOfficialsFirstName: TStringField;
    AuthOfficialsLastName: TStringField;
    ConfigDataset: TXDataWebDataSet;
    ConfigDatasetId: TIntegerField;
    ConfigDatasetHMRCOfficial: TIntegerField;
    ConfigDatasetCharityRef: TStringField;
    ConfigDatasetCharityType: TStringField;
    ConfigDatasetGatewayId: TStringField;
    ConfigDatasetGatewayPassword: TStringField;
    ConfigDatasetRegulator: TStringField;
    ConfigDatasetRegulatorNumber: TStringField;
    ConfigDatasetEndOfYear: TStringField;
    ConfigDatasetOrganisationType: TStringField;
    ConfigDatasetOrganisationName: TStringField;
    ConfigDatasetSubmissionMethod: TStringField;
    ErrorHandling: TLookupComboBox;
    JobsPlacedDateAdded: TDateTimeField;
    JobsPlacedAddedBy: TIntegerField;
    JobsPlacedLastUpdatedBy: TIntegerField;
    JobsPlacedLastUpdated: TDateTimeField;
    JobsPlacedJobCategory: TStringField;
    JobsPlacedLastPolled: TDateTimeField;
    JobsPlacedPollInterval: TLargeintField;
    JobsPlacedPollCount: TIntegerField;
    HMRCPassword: TEdit;
    GAUsers: TClientDataSet;
    UserClaimRef: TEdit;
    InitialCheck: TTimer;
    DisplayClaimDeclaration: TTimer;
    ClaimDeclaration: TXDataWebDataSet;
    ClaimDeclarationId: TIntegerField;
    ClaimDeclarationDateAdded: TDateTimeField;
    ClaimDeclarationAddedBy: TIntegerField;
    ClaimDeclarationLastUpdatedBy: TIntegerField;
    ClaimDeclarationLastUpdated: TDateTimeField;
    ClaimDeclarationClaimId: TIntegerField;
    ClaimDeclarationDeclarationVersion: TIntegerField;
    ClaimDeclarationDeclarationHash: TStringField;
    ClaimDeclarationDeclarationIssueDate: TDateTimeField;
    ClaimDeclarationDeclarationExpiryDate: TDateTimeField;
    ClaimDeclarationDeclarationSignedDate: TDateTimeField;
    ClaimDeclarationDeclarationSignedByUser: TIntegerField;
    ClaimDeclarationDeclarationByName: TStringField;
    ClaimDeclarationDeclarationSigningChannel: TStringField;
    ClaimDeclarationDeclarationStatus: TStringField;
    ClaimDeclarationSignedDeclarationText: TStringField;
    PrepareClaimDataXXX: TTableControl;
    ConfirmClaimCheckBox: TCheckBox;
    OldestDateParameter: TDateTimePicker;
    NewestDateParameter: TDateTimePicker;
    ImportFiles: TLookupComboBox;
    PrepareWaitMessage: TWaitMessage;
    CancelPrepareClaimButton: TButton;
    PrepareClaimButton: TButton;
    PrepareClaimTimer: TTimer;
    DeclarationTextMemo: TMemo;
    PrepareClaimData: TTableControl;
    procedure WebFormCreate(Sender: TObject);
    procedure AgreeCheckBoxClick(Sender: TObject);
    procedure AuthOfficialsAfterOpen(Dataset: TDataSet);
    procedure AuthorisedOfficialChange(Sender: TObject);
    procedure AuthorisedOfficialExit(Sender: TObject);
    procedure ConfigDatasetAfterOpen(Dataset: TDataSet);
    procedure HMRCPasswordExit(Sender: TObject);
    procedure UserClaimRefExit(Sender: TObject);
    procedure InitialCheckTimer(Sender: TObject);
    procedure PlaceJobButtonClick(Sender: TObject);
    procedure ConfirmClaimCheckBoxClick(Sender: TObject);
    procedure PlaceSubmissionJobButtonClick(Sender: TObject);
    //procedure WebFormShow(Sender: TObject);
    procedure UserClaimRefChange(Sender: TObject);
    procedure CancelPrepareClaimButtonClick(Sender: TObject);
    procedure DisplayClaimDeclarationTimer(Sender: TObject);
    procedure ClaimDeclarationAfterPost(DataSet: TDataSet);
    procedure PrepareClaimButtonClick(Sender: TObject);
    procedure PrepareClaimTimerTimer(Sender: TObject);
    procedure ParameterChange(Sender: TObject);
  private
    { Private declarations }
//    FUnclaimedAmount: Currency;
//    FUnclaimedCount: Integer;
    FRememberPasswordEnabled: boolean;
//    FSubmissionJob: boolean;
    FClaimId: integer;
    FGatewayId: string;
    FDeclarationVersionText: string;
    FDeclarationHash: string;

    [async]
    procedure LoadAuthOfficials; async;
    [async]
    procedure GetUnclaimedValues; async;
    [async]
    procedure SearchForAuthOfficials; async;
    [async]
    procedure CheckForRememberPassword; async;

    procedure PopulateDeclarationText;
    procedure SetAuthorisedOfficial;
    [async]
    procedure GetGatewayId; async;
    [async]
    procedure GetDeclarationVersionText; async;
    procedure AddClaimDeclarationTextToMeno(AText: string);
    procedure AddClaimDeclaration;
    procedure MarkLatestSignedDeclarationUsed;
    [async]
    procedure HashClaimDeclaration; async;
    function GetUserName: string;

    [async]
    procedure GetClaimParameters; async;

    procedure UpdateClaimFormForSubmission;
    procedure SetClaimParameters(AClaimParameters: TClaimParameters);
    procedure PopulatePrepareGrid(APrepareClaimData: TPrepareClaimData);
    procedure AddPrepareDataColumn(var ACol: integer; AHeader: string; AValue: Currency);
    [async]
    procedure CancelPrepareClaim; async;
    procedure ResetClaim;

    [async]
    procedure GetPrepareClaimData; async;

  protected
    procedure JobParams(AJobParams: JS.TJSObject); override;
    function MinimumProcessLevel: string; override;
    function JobDescription: string; override;
    function JobDisplayName: string; override;
    function JobClass: string; override;
    function CanPlaceJob: Boolean; override;
//    function CheckForMerging;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;


implementation

{$R *.dfm}

uses
  MainDataModule,
  XData.Web.Client,
  SMX.Web.Document.Utils,
  jsdelphisystem,
  MainForm,
  XData.Dataset.Utils;


procedure TGiftAidClaimJob.WebFormCreate(Sender: TObject);
begin
  inherited;
  AgreeCheckBox.Enabled := False;
  FRememberPasswordEnabled := False;
  OutputOption.Visible := False;
  JobRunType.Visible := False;
  HMRCPassword.Text := '';

  GetUnclaimedValues;

  ErrorHandling.LookupValues.AddPair('OmitRecord', 'Omit Record');
  ErrorHandling.LookupValues.AddPair('CancelSubmission', 'Cancel Submission');
  ErrorHandling.ItemIndex := 0;

  HMRCPassword.Text := '';
  SearchForAuthOfficials;
  CheckForRememberPassword;
  GetClaimParameters;
  InitialCheck.Enabled := True;
//  ResetClaim;

//KSS Below is for the Claim Declaration - commented out until needed
//  GetDeclarationVersionText;
  GetGatewayId;
//KSS Below is for the Claim Declaration - commented out until needed
//  SetAuthorisedOfficial;
  DisplayClaimDeclaration.Enabled := true;
end;

procedure TGiftAidClaimJob.AgreeCheckBoxClick(Sender: TObject);
begin
  ValidateJob;
end;

procedure TGiftAidClaimJob.AuthOfficialsAfterOpen(Dataset: TDataSet);
begin
  PlaceJobButton.Enabled := False;
  LoadAuthOfficials;
end;

procedure TGiftAidClaimJob.AuthorisedOfficialChange(Sender: TObject);
begin
  inherited;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.AuthorisedOfficialExit(Sender: TObject);
begin
  inherited;
end;

{ TGiftAidClaimJob }

procedure TGiftAidClaimJob.CancelPrepareClaimButtonClick(Sender: TObject);
begin
  inherited;
  CancelPrepareClaim;
end;

function TGiftAidClaimJob.CanPlaceJob: Boolean;
var
  sPassword: string;

begin
  result := True;

  if (AuthorisedOfficial.ItemIndex > -1) then
    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsInvalid);
    result := result and (not AuthorisedOfficial.Visible);
  end;

  if (OutputOption.ItemIndex > -1) then
    TDocUtils.setControlValidity(OutputOption.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(OutputOption.ElementID, TValidityState.vsInvalid);
    result := result and (not OutputOption.Visible);
  end;

  if (UserClaimRef.Text <> '') then
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(UserClaimRef.ElementID, TValidityState.vsInvalid);
    result := result and (not UserClaimRef.Visible);
  end;

  if FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vSNone)
  else if (HMRCPassword.Text <> '') or FRememberPasswordEnabled then
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsValid)
  else
  begin
    TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsInvalid);
    result := result and (not HMRCPassword.Visible);
  end;


//KSS  result := result and FSubmissionJob;

  if result and AgreeCheckBox.Checked then
  begin
    sPassword := HMRCPassword.Text;

    if (sPassword.Trim.IsEmpty) and (FRememberPasswordEnabled = false) then
    begin
      TDocUtils.setControlValidity(HMRCPassword.ElementID, TValidityState.vsInvalid);
      SetJobMessage('You must enter your HMRC Gateway password.');
      PlaceJobButton.Enabled := False;
      AgreeCheckBox.Checked := False;
      Exit(False);
    end;

    //TDocUtils.setControlValidity(HMRCPassword.ElementID, TwebValidityState.vsValid);

    if StrToIntDef(AuthorisedOfficial.Value, 0) = 0 then
    begin
      TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsInvalid);
      SetJobMessage('You must select the authorised official to be named on the submission.');
      PlaceJobButton.Enabled := False;
      AgreeCheckBox.Checked := False;
      Exit(False);
    end;

    TDocUtils.setControlValidity(AuthorisedOfficial.ElementID, TValidityState.vsValid);

    if result = True then
      PlaceJobButton.Enabled := True;
  end
  else
  begin
    PlaceJobButton.Enabled := False;
  end;
end;

procedure TGiftAidClaimJob.ConfigDatasetAfterOpen(Dataset: TDataSet);
const
  _Filter = '$filter=(Status eq ''Active'') and (HMRCValidation eq ''Validated'')';
begin
  inherited;
  AuthOfficials.QueryString := _Filter;
  AuthOfficials.Load;
end;

procedure TGiftAidClaimJob.ConfirmClaimCheckBoxClick(Sender: TObject);
begin
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.GetUnclaimedValues;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
//KSS  lRetval := await(TXDataClientResponse,
//KSS    MainData.WebClient.RawInvokeAsync('IGiftAiderService.UnclaimedDonationSummary', []));
//KSS  lResult := lRetval.ResultAsObject;

end;

procedure TGiftAidClaimJob.HMRCPasswordExit(Sender: TObject);
begin
  inherited;
  CanPlaceJob;
end;

function TGiftAidClaimJob.JobClass: string;
begin
  result := 'TPrepareClaimJob';
end;

function TGiftAidClaimJob.JobDescription: string;
begin
  result := 'Claiming Gift Aid - Preparation';
end;

function TGiftAidClaimJob.JobDisplayName: string;
begin
  result := 'Gift Aid Claim Preparation';
end;

procedure TGiftAidClaimJob.JobParams(AJobParams: JS.TJSObject);
begin
  inherited;
  AJobParams.Properties['HMRCPassword'] := HMRCPassword.Text;
  AJobParams.Properties['HMRCOfficial'] := StrToIntDef(AuthorisedOfficial.Value, 0);
  AJobParams.Properties['ErrorHandling'] := ErrorHandling.Value;
  AJobParams.Properties['ClaimRef'] := UserClaimRef.Text;
  AJobParams.Properties['ClaimId'] := FClaimId;

  AJobParams.Properties['ImportId'] := ImportFiles.Value;
  AJobParams.Properties['EarliestClaimDate'] := FormatDateTime('YYYY/MM/DD', OldestDateParameter.Date);
  AJobParams.Properties['LatestClaimDate'] := FormatDateTime('YYYY/MM/DD', NewestDateParameter.Date);
end;

procedure TGiftAidClaimJob.LoadAuthOfficials;
begin
  while not AuthOfficials.Eof do
  begin
    AuthorisedOfficial.LookupValues.AddPair(AuthOfficialsId.AsString, AuthOfficialsFirstName.Value + ' ' +
      AuthOfficialsLastName.Value);
    AuthOfficials.Next;
  end;

  if AuthOfficials.RecordCount = 1 then
    AuthorisedOfficial.ItemIndex := 0
  else
    AuthorisedOfficial.Value := ConfigDatasetHMRCOfficial.AsString;

end;

function TGiftAidClaimJob.MinimumProcessLevel: string;
begin
  result := 'Anyone';//KSS 'AnyAdministrator';
end;

procedure TGiftAidClaimJob.ParameterChange(Sender: TObject);
begin
  ConfirmClaimCheckBox.Enabled := False;
end;

procedure TGiftAidClaimJob.PlaceJobButtonClick(Sender: TObject);
begin
  inherited;
  if assigned(MainPage) then
    MainPage.DisableSubmissionLink;
end;

procedure TGiftAidClaimJob.PlaceSubmissionJobButtonClick(Sender: TObject);
begin
  //New Job so set JobId to 0
  JobId := 0;

  PlaceJobButtonClick(Sender);
  PlaceJobManagedExternally := False;

//KSS Below is for the Claim Declaration - commented out until needed
//  AddClaimDeclaration;
end;

procedure TGiftAidClaimJob.SearchForAuthOfficials;
const
  _Filter = '$filter=(Status eq ''Active'') and (HMRCValidation eq ''Validated'')';
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;

  lList: JS.TJSArray;

  lIdx: Integer;
  lInternalId: Integer;
  lFirstName: string;
  lSecondName: string;
  lUserName: string;
  OffUsers: JS.TJSObject;
begin

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.GetHMRCAuthorisedUsers', [0]));
  lResult := lRetval.ResultAsObject;
  lList := JS.toArray(lResult['value']);

  if lList <> nil then
  begin
    for lIdx := 0 to (lList.Length-1) do
    begin
      OffUsers := JS.toObject(lList.Elements[lIdx]);

      lInternalId := JS.toInteger(OffUsers['InternalId']);
      lFirstName := JS.toString(OffUsers['GivenName']);
      lSecondName := JS.toString(OffUsers['LastName']);

      lUserName := lFirstName + ' ' + lSecondName;
      AuthorisedOfficial.LookupValues.AddPair(inttostr(lInternalId), lUserName);
    end;
  end;

  //It is safe to say there will be an HMRCAuthorisedUser - the form is disabled if there isn't one
  AuthorisedOfficial.ItemIndex := 0;
end;

procedure TGiftAidClaimJob.UserClaimRefChange(Sender: TObject);
begin
  inherited;
//KSS  PrepareButtonEnbled;
end;

procedure TGiftAidClaimJob.UserClaimRefExit(Sender: TObject);
begin
  inherited;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.CheckForRememberPassword;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.HMRCPasswordSavingEnabled', [1]));
  FRememberPasswordEnabled := boolean(TJSObject(lRetval.Result)['value']);

  HMRCPassword.Enabled := not FRememberPasswordEnabled;
end;

procedure TGiftAidClaimJob.InitialCheckTimer(Sender: TObject);
begin
  InitialCheck.Enabled := False;
//  CanPlaceJob;

  ResetClaim;
end;

procedure TGiftAidClaimJob.ClaimDeclarationAfterPost(DataSet: TDataSet);
begin
  inherited;
  ClaimDeclaration.ApplyUpdates;
end;

procedure TGiftAidClaimJob.HashClaimDeclaration;
var
  lRetval: TXDataClientResponse;
  lResponse: TJSObject;
  lDeclarationText: string;

begin

  lDeclarationText := DeclarationTextMemo.Lines.Text;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.HashDeclaration', [lDeclarationText]));

  lResponse := lRetval.ResultAsObject;
  FDeclarationHash := JS.ToString(lResponse['value']);

end;

procedure TGiftAidClaimJob.SetAuthorisedOfficial;
var
  lAuthorisedOfficial: string;
  lAuthorisedOfficialId: integer;
begin
  lAuthorisedOfficial := GetUserName;
  lAuthorisedOfficialId := MainData.AppUser.InternalId;

  AuthorisedOfficial.LookupValues.AddPair(lAuthorisedOfficialId.ToString, lAuthorisedOfficial);
  AuthorisedOfficial.ItemIndex := 0;
end;

procedure TGiftAidClaimJob.GetGatewayId;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IUserManagerService.GetGatewayId', [1]));
  FGatewayId := string(TJSObject(lRetval.Result)['value']);

end;

procedure TGiftAidClaimJob.DisplayClaimDeclarationTimer(Sender: TObject);
begin
  DisplayClaimDeclaration.Enabled := False;
  UserClaimRef.Clear;
  UserClaimRef.ClearSelection;

//KSS Below is for the Claim Declaration - commented out until needed
//  PopulateDeclarationText;
  CanPlaceJob;
end;

procedure TGiftAidClaimJob.PopulateDeclarationText;
var
  lText: string;
  lName: string;
  lTodaysDate: string;
  lCharityName: string;
begin
  lText := FDeclarationVersionText;

  lName := AuthorisedOfficial.DisplayText;
  lTodaysDate := FormatDateTime('dd/mm/yyyy', Now);
  lCharityName := MainData.OrganisationDisplayName;

  //~ is used as a deliminter in the memo to drop text down to the next line. Used <CRLF> in
  //the text as it is more meaningful to the user
  lText := StringReplace(lText, '<CRLF>', '~', [rfReplaceAll, rfIgnoreCase]);

  lText := StringReplace(lText, '[Full Name]', lName, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Your Gateway ID]', FGatewayId, [rfReplaceAll, rfIgnoreCase]);
  lText := StringReplace(lText, '[Date]', lTodaysDate, [rfReplaceAll, rfIgnoreCase]);

  lText := StringReplace(lText, '[Charity Name]', lCharityName, [rfReplaceAll, rfIgnoreCase]);

//KSS Below is for the Claim Declaration - commented out until needed
//  AddClaimDeclarationTextToMeno(lText);
//KSS Below is for the Claim Declaration - commented out until needed
//  HashClaimDeclaration;
end;

procedure TGiftAidClaimJob.GetDeclarationVersionText;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetDeclarationVersionText', []));
  FDeclarationVersionText := string(TJSObject(lRetval.Result)['value']);
end;


procedure TGiftAidClaimJob.AddClaimDeclarationTextToMeno(AText: string);
begin
  DeclarationTextMemo.Clear;
  DeclarationTextMemo.Lines.StrictDelimiter := true;
  DeclarationTextMemo.Lines.Delimiter := '~';
  DeclarationTextMemo.Lines.DelimitedText := AText;
end;

procedure TGiftAidClaimJob.AddClaimDeclaration;
var
  lName: string;
begin
  ClaimDeclaration.Active := True;
  ClaimDeclaration.Insert;
  ClaimDeclaration.FieldByName('ClaimId').AsInteger := FClaimId;
  ClaimDeclaration.FieldByName('DeclarationVersion').AsInteger := 1;
  ClaimDeclaration.FieldByName('DeclarationHash').AsString := FDeclarationHash;
  ClaimDeclaration.FieldByName('DeclarationIssueDate').AsDateTime := Now;
  ClaimDeclaration.FieldByName('DeclarationExpiryDate').AsDateTime := Now + 10;
  ClaimDeclaration.FieldByName('DeclarationSignedDate').AsDateTime := Now;
  ClaimDeclaration.FieldByName('DeclarationSignedByUser').AsInteger := MainData.AppUser.InternalId;
  ClaimDeclaration.FieldByName('DeclarationByName').AsString := GetUserName;
  ClaimDeclaration.FieldByName('DeclarationSigningChannel').AsString := 'GiftAider';
  ClaimDeclaration.FieldByName('DeclarationStatus').AsString := 'Signed';
  ClaimDeclaration.FieldByName('SignedDeclarationText').AsString := DeclarationTextMemo.Lines.Text;
  ClaimDeclaration.Post;
end;

procedure TGiftAidClaimJob.MarkLatestSignedDeclarationUsed;
var
  lLatestDeclarationId: Integer;
begin
  lLatestDeclarationId := 0;
  ClaimDeclaration.Active := True;
  ClaimDeclaration.First;
  while not ClaimDeclaration.Eof do
  begin
    if (ClaimDeclarationClaimId.AsInteger = FClaimId) and
      SameText(ClaimDeclarationDeclarationStatus.AsString, 'Signed') and
      (ClaimDeclarationId.AsInteger > lLatestDeclarationId) then
      lLatestDeclarationId := ClaimDeclarationId.AsInteger;
    ClaimDeclaration.Next;
  end;

  if (lLatestDeclarationId > 0) and ClaimDeclaration.Locate('Id', lLatestDeclarationId, []) then
  begin
    ClaimDeclaration.Edit;
    ClaimDeclarationDeclarationStatus.AsString := 'Used';
    ClaimDeclaration.Post;
  end;
end;

function TGiftAidClaimJob.GetUserName: string;
begin
  result := MainData.AppUser.GivenName + ' ' + MainData.AppUser.LastName;
end;

procedure TGiftAidClaimJob.GetPrepareClaimData;
var
  lRetval: TXDataClientResponse;
  lPrepareClaimData: TPrepareClaimData;
  lResponse: TJSObject;
  lImportId: string;//integer;
begin
  lImportId := ImportFiles.Value;

  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.PrepareClaimDataDirect', [lImportId.ToInteger, OldestDateParameter.Date, NewestDateParameter.Date]));

  lResponse := lRetval.ResultAsObject;
  lPrepareClaimData := TPrepareClaimData.Create;
  lPrepareClaimData.Assign(lResponse);

  PopulatePrepareGrid(lPrepareClaimData);
  PrepareWaitMessage.Hide;

end;

procedure TGiftAidClaimJob.PrepareClaimButtonClick(Sender: TObject);
begin
  if ImportFiles.ItemIndex > -1 then
  begin
    ResetClaim;
    PrepareWaitMessage.Show;
    GetPrepareClaimData;
    AgreeCheckBox.Enabled := False;
    AgreeCheckBox.Checked := False;
  end;
end;

procedure TGiftAidClaimJob.PrepareClaimTimerTimer(Sender: TObject);
begin
  PrepareClaimTimer.Enabled := False;
  GetPrepareClaimData;
end;

procedure TGiftAidClaimJob.PopulatePrepareGrid(APrepareClaimData: TPrepareClaimData);
var
  lCol: integer;
begin
  PrepareClaimData.Cells[0,1] := inttostr(APrepareClaimData.DonationCount);
  lCol := 1; //Current
  AddPrepareDataColumn(lCol, 'Amount', APrepareClaimData.Amount);
  AddPrepareDataColumn(lCol, 'Gift Aid', APrepareClaimData.GiftAid);

  AddPrepareDataColumn(lCol, 'GASDS', APrepareClaimData.GASDS);
  AddPrepareDataColumn(lCol, 'GASDS Adj.', APrepareClaimData.GASDSAdjustments);
  AddPrepareDataColumn(lCol, 'Aggregated', APrepareClaimData.AggregatedDonations);
  AddPrepareDataColumn(lCol, 'Other Inc.', APrepareClaimData.OtherIncome);
  AddPrepareDataColumn(lCol, 'Adj.', APrepareClaimData.Adjustments);
  AddPrepareDataColumn(lCol, 'Comm. Build', APrepareClaimData.CommunityBuildings);

  FClaimId := APrepareClaimData.ClaimId;

  if APrepareClaimData.Complete then
    UpdateClaimFormForSubmission;
end;

procedure TGiftAidClaimJob.AddPrepareDataColumn(var ACol: integer; AHeader: string; AValue: Currency);
begin
  if AValue <> 0.00 then
  begin
    inc(ACol);
    PrepareClaimData.ColCount := ACol;
    PrepareClaimData.Cells[ACol-1,0] := AHeader;
    PrepareClaimData.Cells[ACol-1,1] := format('%0.2f', [AValue]);
  end;
end;

procedure TGiftAidClaimJob.GetClaimParameters;
var
  lRetval: TXDataClientResponse;
  lClaimParameters: TClaimParameters;
  lUserClaimRef: string;
  lInt: integer;
  lResponse: TJSObject;

begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetClaimParameters', []));

  lResponse := lRetval.ResultAsObject;
  lClaimParameters := TClaimParameters.Create;
  lClaimParameters.Assign(lResponse);

  SetClaimParameters(lClaimParameters);
end;

procedure TGiftAidClaimJob.UpdateClaimFormForSubmission;
begin
  ConfirmClaimCheckBox.Enabled := True;
  AgreeCheckBox.Enabled := True;
  CancelPrepareClaimButton.Enabled := True;
end;

procedure TGiftAidClaimJob.SetClaimParameters(AClaimParameters: TClaimParameters);
var
  lOldestDate, lNewestDate: TDate;
  lIdx: integer;
  lImportFileNames: TStringList;
  lImportIds: TStringList;
  lImportFileName: string;
  lImportId: string;

begin
  lImportFileNames := TStringList.Create;
  lImportFileNames.StrictDelimiter := True;
  lImportFileNames.CommaText := AClaimParameters.ImportFiles;
  lImportIds := TStringList.Create;
  lImportIds.StrictDelimiter := True;
  lImportIds.CommaText := AClaimParameters.ImportIds;

  try
    for lIdx := 0  to lImportFileNames.Count-1 do
    begin
      lImportFileName := lImportFileNames[lIdx];
      lImportId := lImportIds[lIdx];
      ImportFiles.LookupValues.AddPair(lImportId, lImportFileName);
    end;

    if lIdx > -1 then
      ImportFiles.ItemIndex := 0;

    lOldestDate := strtodate(AClaimParameters.OldestDate);
    lNewestDate := strtodate(AClaimParameters.NewestDate);

  finally
    lImportFileNames.Free;
    lImportIds.Free;
  end;
  OldestDateParameter.Date := lOldestDate;
  NewestDateParameter.Date := lNewestDate;
end;

procedure TGiftAidClaimJob.CancelPrepareClaim;
begin
  ResetClaim;
end;

procedure TGiftAidClaimJob.ResetClaim;
var
  lIdx: Integer;
begin
  for lIdx := 1 to PrepareClaimData.ColCount-1 do
  begin
    PrepareClaimData.Cells[lIdx,0] := '';
    PrepareClaimData.Cells[lIdx,1] := '';
  end;

  PrepareClaimData.ColCount := 3;
  PrepareClaimData.Cells[0,0] := 'Donation Count';
  PrepareClaimData.Cells[0,1] := '0';
  PrepareClaimData.Cells[1,0] := 'Amount';
  PrepareClaimData.Cells[1,1] := '0.00';
  PrepareClaimData.Cells[2,0] := 'GiftAid';
  PrepareClaimData.Cells[2,1] := '0.00';

  CancelPrepareClaimButton.Enabled := False;
  PrepareClaimButton.Enabled := True;
  ConfirmClaimCheckbox.Enabled := False;
  ConfirmClaimCheckbox.Checked := False;
  UserClaimRef.Text := '';
  UserClaimRef.Clear;
  UserClaimRef.ClearSelection;
  UserClaimRef.Enabled := True;
  FJobId := 0;
  FClaimId := 0;
end;


procedure TGiftAidClaimJob.LoadDFMValues;
begin
  inherited LoadDFMValues;

  AgreeCheckBox := TCheckBox.Create('AgreeCheckBox');
  AuthorisedOfficial := TLookupComboBox.Create('AuthorisedOfficial');
  ErrorHandling := TLookupComboBox.Create('ErrorHandling');
  HMRCPassword := TEdit.Create('HMRCPassword');
  UserClaimRef := TEdit.Create('UserClaimRef');
  PrepareClaimDataXXX := TTableControl.Create('PrepareClaimDataXXX');
  ConfirmClaimCheckBox := TCheckBox.Create('ConfirmClaim');
  OldestDateParameter := TDateTimePicker.Create('OldestDateParameter');
  NewestDateParameter := TDateTimePicker.Create('NewestDateParameter');
  ImportFiles := TLookupComboBox.Create('ImportReference');
  PrepareWaitMessage := TWaitMessage.Create(Self);
  CancelPrepareClaimButton := TButton.Create('CancelPrepareClaimButton');
  PrepareClaimButton := TButton.Create('PrepareClaimButton');
  DeclarationTextMemo := TMemo.Create('DeclarationTextMemo');
  PrepareClaimData := TTableControl.Create('PrepareClaimData');
  JobsPlacedDateAdded := TDateTimeField.Create(Self);
  JobsPlacedAddedBy := TIntegerField.Create(Self);
  JobsPlacedLastUpdatedBy := TIntegerField.Create(Self);
  JobsPlacedLastUpdated := TDateTimeField.Create(Self);
  JobsPlacedJobCategory := TStringField.Create(Self);
  JobsPlacedLastPolled := TDateTimeField.Create(Self);
  JobsPlacedPollInterval := TLargeintField.Create(Self);
  JobsPlacedPollCount := TIntegerField.Create(Self);
  AuthOfficials := TXDataWebDataSet.Create(Self);
  AuthOfficialsId := TIntegerField.Create(Self);
  AuthOfficialsFirstName := TStringField.Create(Self);
  AuthOfficialsLastName := TStringField.Create(Self);
  ConfigDataset := TXDataWebDataSet.Create(Self);
  ConfigDatasetId := TIntegerField.Create(Self);
  ConfigDatasetHMRCOfficial := TIntegerField.Create(Self);
  ConfigDatasetCharityRef := TStringField.Create(Self);
  ConfigDatasetCharityType := TStringField.Create(Self);
  ConfigDatasetGatewayId := TStringField.Create(Self);
  ConfigDatasetGatewayPassword := TStringField.Create(Self);
  ConfigDatasetRegulator := TStringField.Create(Self);
  ConfigDatasetRegulatorNumber := TStringField.Create(Self);
  ConfigDatasetEndOfYear := TStringField.Create(Self);
  ConfigDatasetOrganisationType := TStringField.Create(Self);
  ConfigDatasetOrganisationName := TStringField.Create(Self);
  ConfigDatasetSubmissionMethod := TStringField.Create(Self);
  GAUsers := TClientDataSet.Create(Self);
  InitialCheck := TTimer.Create(Self);
  DisplayClaimDeclaration := TTimer.Create(Self);
  ClaimDeclaration := TXDataWebDataSet.Create(Self);
  ClaimDeclarationId := TIntegerField.Create(Self);
  ClaimDeclarationDateAdded := TDateTimeField.Create(Self);
  ClaimDeclarationAddedBy := TIntegerField.Create(Self);
  ClaimDeclarationLastUpdatedBy := TIntegerField.Create(Self);
  ClaimDeclarationLastUpdated := TDateTimeField.Create(Self);
  ClaimDeclarationClaimId := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationVersion := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationHash := TStringField.Create(Self);
  ClaimDeclarationDeclarationIssueDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationExpiryDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedDate := TDateTimeField.Create(Self);
  ClaimDeclarationDeclarationSignedByUser := TIntegerField.Create(Self);
  ClaimDeclarationDeclarationByName := TStringField.Create(Self);
  ClaimDeclarationDeclarationSigningChannel := TStringField.Create(Self);
  ClaimDeclarationDeclarationStatus := TStringField.Create(Self);
  ClaimDeclarationSignedDeclarationText := TStringField.Create(Self);
  PrepareClaimTimer := TTimer.Create(Self);

  JobsPlacedTable.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  PlaceJobButton.BeforeLoadDFMValues;
  OutputOption.BeforeLoadDFMValues;
  JobVisibility.BeforeLoadDFMValues;
  WaitMessage.BeforeLoadDFMValues;
  JobRunType.BeforeLoadDFMValues;
  AgreeCheckBox.BeforeLoadDFMValues;
  AuthorisedOfficial.BeforeLoadDFMValues;
  ErrorHandling.BeforeLoadDFMValues;
  HMRCPassword.BeforeLoadDFMValues;
  UserClaimRef.BeforeLoadDFMValues;
  PrepareClaimDataXXX.BeforeLoadDFMValues;
  ConfirmClaimCheckBox.BeforeLoadDFMValues;
  OldestDateParameter.BeforeLoadDFMValues;
  NewestDateParameter.BeforeLoadDFMValues;
  ImportFiles.BeforeLoadDFMValues;
  PrepareWaitMessage.BeforeLoadDFMValues;
  CancelPrepareClaimButton.BeforeLoadDFMValues;
  PrepareClaimButton.BeforeLoadDFMValues;
  DeclarationTextMemo.BeforeLoadDFMValues;
  PrepareClaimData.BeforeLoadDFMValues;
  JobsPlaced.BeforeLoadDFMValues;
  JobsPlacedDateAdded.BeforeLoadDFMValues;
  JobsPlacedAddedBy.BeforeLoadDFMValues;
  JobsPlacedLastUpdatedBy.BeforeLoadDFMValues;
  JobsPlacedLastUpdated.BeforeLoadDFMValues;
  JobsPlacedJobCategory.BeforeLoadDFMValues;
  JobsPlacedLastPolled.BeforeLoadDFMValues;
  JobsPlacedPollInterval.BeforeLoadDFMValues;
  JobsPlacedPollCount.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  AuthOfficials.BeforeLoadDFMValues;
  AuthOfficialsId.BeforeLoadDFMValues;
  AuthOfficialsFirstName.BeforeLoadDFMValues;
  AuthOfficialsLastName.BeforeLoadDFMValues;
  ConfigDataset.BeforeLoadDFMValues;
  ConfigDatasetId.BeforeLoadDFMValues;
  ConfigDatasetHMRCOfficial.BeforeLoadDFMValues;
  ConfigDatasetCharityRef.BeforeLoadDFMValues;
  ConfigDatasetCharityType.BeforeLoadDFMValues;
  ConfigDatasetGatewayId.BeforeLoadDFMValues;
  ConfigDatasetGatewayPassword.BeforeLoadDFMValues;
  ConfigDatasetRegulator.BeforeLoadDFMValues;
  ConfigDatasetRegulatorNumber.BeforeLoadDFMValues;
  ConfigDatasetEndOfYear.BeforeLoadDFMValues;
  ConfigDatasetOrganisationType.BeforeLoadDFMValues;
  ConfigDatasetOrganisationName.BeforeLoadDFMValues;
  ConfigDatasetSubmissionMethod.BeforeLoadDFMValues;
  GAUsers.BeforeLoadDFMValues;
  InitialCheck.BeforeLoadDFMValues;
  DisplayClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclaration.BeforeLoadDFMValues;
  ClaimDeclarationId.BeforeLoadDFMValues;
  ClaimDeclarationDateAdded.BeforeLoadDFMValues;
  ClaimDeclarationAddedBy.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdatedBy.BeforeLoadDFMValues;
  ClaimDeclarationLastUpdated.BeforeLoadDFMValues;
  ClaimDeclarationClaimId.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationVersion.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationHash.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationIssueDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationExpiryDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedDate.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSignedByUser.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationByName.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationSigningChannel.BeforeLoadDFMValues;
  ClaimDeclarationDeclarationStatus.BeforeLoadDFMValues;
  ClaimDeclarationSignedDeclarationText.BeforeLoadDFMValues;
  PrepareClaimTimer.BeforeLoadDFMValues;
  try
    JobsPlacedTable.Top := 8;
    CancelButton.Left := 414;
    SetEvent(PlaceJobButton, Self, 'OnClick', 'PlaceSubmissionJobButtonClick');
    OutputOption.Top := 263;
    JobVisibility.Visible := False;
    WaitMessage.Left := 104;
    WaitMessage.Top := 425;
    JobRunType.Visible := False;
    AgreeCheckBox.SetParentComponent(Self);
    AgreeCheckBox.Name := 'AgreeCheckBox';
    AgreeCheckBox.Left := 64;
    AgreeCheckBox.Top := 350;
    AgreeCheckBox.Width := 113;
    AgreeCheckBox.Height := 22;
    AgreeCheckBox.Caption := 'I Agree';
    AgreeCheckBox.ChildOrder := 10;
    AgreeCheckBox.ElementClassName := 'custom-control custom-checkbox';
    AgreeCheckBox.ElementButtonClassName := 'from-control-input';
    AgreeCheckBox.ElementLabelClassName := 'form-control-label';
    AgreeCheckBox.ElementFont := efCSS;
    AgreeCheckBox.ElementPosition := epIgnore;
    AgreeCheckBox.Enabled := False;
    AgreeCheckBox.HeightStyle := ssAuto;
    AgreeCheckBox.HeightPercent := 100.000000000000000000;
    AgreeCheckBox.WidthStyle := ssAuto;
    AgreeCheckBox.WidthPercent := 100.000000000000000000;
    SetEvent(AgreeCheckBox, Self, 'OnClick', 'AgreeCheckBoxClick');
    AuthorisedOfficial.SetParentComponent(Self);
    AuthorisedOfficial.Name := 'AuthorisedOfficial';
    AuthorisedOfficial.Left := 352;
    AuthorisedOfficial.Top := 378;
    AuthorisedOfficial.Width := 249;
    AuthorisedOfficial.Height := 22;
    AuthorisedOfficial.ElementClassName := 'form-select';
    AuthorisedOfficial.ElementFont := efCSS;
    AuthorisedOfficial.HeightPercent := 100.000000000000000000;
    AuthorisedOfficial.WidthPercent := 100.000000000000000000;
    SetEvent(AuthorisedOfficial, Self, 'OnChange', 'AuthorisedOfficialChange');
    SetEvent(AuthorisedOfficial, Self, 'OnExit', 'AuthorisedOfficialExit');
    AuthorisedOfficial.ItemIndex := -1;
    ErrorHandling.SetParentComponent(Self);
    ErrorHandling.Name := 'ErrorHandling';
    ErrorHandling.Left := 63;
    ErrorHandling.Top := 380;
    ErrorHandling.Width := 249;
    ErrorHandling.Height := 22;
    ErrorHandling.ElementClassName := 'form-select';
    ErrorHandling.ElementFont := efCSS;
    ErrorHandling.HeightPercent := 100.000000000000000000;
    ErrorHandling.WidthPercent := 100.000000000000000000;
    ErrorHandling.ItemIndex := -1;
    HMRCPassword.SetParentComponent(Self);
    HMRCPassword.Name := 'HMRCPassword';
    HMRCPassword.Left := 352;
    HMRCPassword.Top := 350;
    HMRCPassword.Width := 249;
    HMRCPassword.Height := 22;
    HMRCPassword.AutoCompletion := acNone;
    HMRCPassword.AutoSelect := False;
    HMRCPassword.ChildOrder := 13;
    HMRCPassword.ElementClassName := 'form-control';
    HMRCPassword.ElementPosition := epIgnore;
    HMRCPassword.HeightStyle := ssAuto;
    HMRCPassword.HeightPercent := 100.000000000000000000;
    HMRCPassword.PasswordChar := '*';
    HMRCPassword.WidthStyle := ssAuto;
    HMRCPassword.WidthPercent := 100.000000000000000000;
    SetEvent(HMRCPassword, Self, 'OnExit', 'HMRCPasswordExit');
    UserClaimRef.SetParentComponent(Self);
    UserClaimRef.Name := 'UserClaimRef';
    UserClaimRef.Left := 134;
    UserClaimRef.Top := 408;
    UserClaimRef.Width := 121;
    UserClaimRef.Height := 22;
    UserClaimRef.AutoSelect := False;
    UserClaimRef.CharCase := wecUpperCase;
    UserClaimRef.ChildOrder := 13;
    UserClaimRef.ElementPosition := epIgnore;
    UserClaimRef.HeightStyle := ssAuto;
    UserClaimRef.HeightPercent := 100.000000000000000000;
    UserClaimRef.MaxLength := 20;
    UserClaimRef.WidthStyle := ssAuto;
    UserClaimRef.WidthPercent := 100.000000000000000000;
    SetEvent(UserClaimRef, Self, 'OnChange', 'UserClaimRefChange');
    SetEvent(UserClaimRef, Self, 'OnExit', 'UserClaimRefExit');
    PrepareClaimDataXXX.SetParentComponent(Self);
    PrepareClaimDataXXX.Name := 'PrepareClaimDataXXX';
    PrepareClaimDataXXX.Left := 64;
    PrepareClaimDataXXX.Top := 216;
    PrepareClaimDataXXX.Width := 488;
    PrepareClaimDataXXX.Height := 41;
    PrepareClaimDataXXX.HeightStyle := ssAuto;
    PrepareClaimDataXXX.WidthStyle := ssAuto;
    PrepareClaimDataXXX.BorderColor := clSilver;
    PrepareClaimDataXXX.ChildOrder := 15;
    PrepareClaimDataXXX.ElementFont := efCSS;
    PrepareClaimDataXXX.ElementHeaderClassName := 'thead-light';
    PrepareClaimDataXXX.ElementPosition := epIgnore;
    PrepareClaimDataXXX.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PrepareClaimDataXXX.Header.Caption := 'WOOOOOOOF';
    PrepareClaimDataXXX.Options.CellBorders := True;
    PrepareClaimDataXXX.Options.ResizeColumns := True;
    PrepareClaimDataXXX.Visible := False;
    PrepareClaimDataXXX.ColCount := 2;
    PrepareClaimDataXXX.RowCount := 2;
    ConfirmClaimCheckBox.SetParentComponent(Self);
    ConfirmClaimCheckBox.Name := 'ConfirmClaimCheckBox';
    ConfirmClaimCheckBox.Left := 64;
    ConfirmClaimCheckBox.Top := 183;
    ConfirmClaimCheckBox.Width := 145;
    ConfirmClaimCheckBox.Height := 22;
    ConfirmClaimCheckBox.Caption := 'Confirm Claim';
    ConfirmClaimCheckBox.ChildOrder := 16;
    ConfirmClaimCheckBox.ElementClassName := 'form-check-input';
    ConfirmClaimCheckBox.ElementPosition := epIgnore;
    ConfirmClaimCheckBox.Enabled := False;
    ConfirmClaimCheckBox.Font.Charset := DEFAULT_CHARSET;
    ConfirmClaimCheckBox.Font.Color := clWindowText;
    ConfirmClaimCheckBox.Font.Height := -18;
    ConfirmClaimCheckBox.Font.Name := 'Segoe UI';
    ConfirmClaimCheckBox.Font.Style := [];
    ConfirmClaimCheckBox.HeightStyle := ssAuto;
    ConfirmClaimCheckBox.HeightPercent := 100.000000000000000000;
    ConfirmClaimCheckBox.ParentFont := False;
    ConfirmClaimCheckBox.WidthStyle := ssAuto;
    ConfirmClaimCheckBox.WidthPercent := 100.000000000000000000;
    OldestDateParameter.SetParentComponent(Self);
    OldestDateParameter.Name := 'OldestDateParameter';
    OldestDateParameter.Left := 248;
    OldestDateParameter.Top := 167;
    OldestDateParameter.Width := 160;
    OldestDateParameter.Height := 22;
    OldestDateParameter.ElementClassName := 'form-control';
    OldestDateParameter.HeightStyle := ssAuto;
    OldestDateParameter.WidthStyle := ssAuto;
    OldestDateParameter.BorderStyle := bsSingle;
    OldestDateParameter.ChildOrder := 18;
    OldestDateParameter.Color := clWhite;
    OldestDateParameter.Date := 46090.416217013890000000;
    OldestDateParameter.ElementPosition := epIgnore;
    OldestDateParameter.Role := '';
    OldestDateParameter.Text := '';
    SetEvent(OldestDateParameter, Self, 'OnChange', 'ParameterChange');
    NewestDateParameter.SetParentComponent(Self);
    NewestDateParameter.Name := 'NewestDateParameter';
    NewestDateParameter.Left := 248;
    NewestDateParameter.Top := 195;
    NewestDateParameter.Width := 160;
    NewestDateParameter.Height := 22;
    NewestDateParameter.ElementClassName := 'form-control';
    NewestDateParameter.HeightStyle := ssAuto;
    NewestDateParameter.WidthStyle := ssAuto;
    NewestDateParameter.BorderStyle := bsSingle;
    NewestDateParameter.ChildOrder := 18;
    NewestDateParameter.Color := clWhite;
    NewestDateParameter.Date := 46090.416217013890000000;
    NewestDateParameter.ElementPosition := epIgnore;
    NewestDateParameter.Role := '';
    NewestDateParameter.Text := '';
    SetEvent(NewestDateParameter, Self, 'OnChange', 'ParameterChange');
    ImportFiles.SetParentComponent(Self);
    ImportFiles.Name := 'ImportFiles';
    ImportFiles.Left := 248;
    ImportFiles.Top := 128;
    ImportFiles.Width := 160;
    ImportFiles.Height := 22;
    ImportFiles.ElementClassName := 'form-select';
    ImportFiles.ElementPosition := epIgnore;
    ImportFiles.HeightStyle := ssAuto;
    ImportFiles.HeightPercent := 100.000000000000000000;
    ImportFiles.WidthStyle := ssAuto;
    ImportFiles.WidthPercent := 100.000000000000000000;
    SetEvent(ImportFiles, Self, 'OnChange', 'ParameterChange');
    ImportFiles.ItemIndex := -1;
    PrepareWaitMessage.SetParentComponent(Self);
    PrepareWaitMessage.Name := 'PrepareWaitMessage';
    PrepareWaitMessage.Left := 8;
    PrepareWaitMessage.Top := 288;
    PrepareWaitMessage.Width := 24;
    PrepareWaitMessage.Height := 24;
    PrepareWaitMessage.Opacity := 0.200000000000000000;
    PrepareWaitMessage.Picture.LoadFromFile('GiftAidClaimForm.PrepareWaitMessage.Picture.gif');
    CancelPrepareClaimButton.SetParentComponent(Self);
    CancelPrepareClaimButton.Name := 'CancelPrepareClaimButton';
    CancelPrepareClaimButton.Left := 424;
    CancelPrepareClaimButton.Top := 132;
    CancelPrepareClaimButton.Width := 96;
    CancelPrepareClaimButton.Height := 25;
    CancelPrepareClaimButton.Caption := 'Cancel Prepare Claim';
    CancelPrepareClaimButton.ChildOrder := 21;
    CancelPrepareClaimButton.ElementClassName := 'btn btn-secondary';
    CancelPrepareClaimButton.ElementPosition := epIgnore;
    CancelPrepareClaimButton.HeightStyle := ssAuto;
    CancelPrepareClaimButton.HeightPercent := 100.000000000000000000;
    CancelPrepareClaimButton.WidthStyle := ssAuto;
    CancelPrepareClaimButton.WidthPercent := 100.000000000000000000;
    SetEvent(CancelPrepareClaimButton, Self, 'OnClick', 'CancelPrepareClaimButtonClick');
    PrepareClaimButton.SetParentComponent(Self);
    PrepareClaimButton.Name := 'PrepareClaimButton';
    PrepareClaimButton.Left := 64;
    PrepareClaimButton.Top := 136;
    PrepareClaimButton.Width := 178;
    PrepareClaimButton.Height := 25;
    PrepareClaimButton.Caption := 'Prepare Claim';
    PrepareClaimButton.ChildOrder := 22;
    PrepareClaimButton.ElementClassName := 'btn btn-secondary';
    PrepareClaimButton.ElementPosition := epIgnore;
    PrepareClaimButton.HeightStyle := ssAuto;
    PrepareClaimButton.HeightPercent := 100.000000000000000000;
    PrepareClaimButton.WidthStyle := ssAuto;
    PrepareClaimButton.WidthPercent := 100.000000000000000000;
    SetEvent(PrepareClaimButton, Self, 'OnClick', 'PrepareClaimButtonClick');
    DeclarationTextMemo.SetParentComponent(Self);
    DeclarationTextMemo.Name := 'DeclarationTextMemo';
    DeclarationTextMemo.Left := 400;
    DeclarationTextMemo.Top := 93;
    DeclarationTextMemo.Width := 185;
    DeclarationTextMemo.Height := 89;
    DeclarationTextMemo.ElementPosition := epIgnore;
    DeclarationTextMemo.HeightStyle := ssAuto;
    DeclarationTextMemo.HeightPercent := 100.000000000000000000;
    DeclarationTextMemo.Lines.BeginUpdate;
    try
      DeclarationTextMemo.Lines.Clear;
      DeclarationTextMemo.Lines.Add('DeclarationTextMemo');
    finally
      DeclarationTextMemo.Lines.EndUpdate;
    end;
    DeclarationTextMemo.ReadOnly := True;
    DeclarationTextMemo.SelLength := 0;
    DeclarationTextMemo.SelStart := 0;
    DeclarationTextMemo.Visible := False;
    DeclarationTextMemo.WidthStyle := ssAuto;
    DeclarationTextMemo.WidthPercent := 100.000000000000000000;
    PrepareClaimData.SetParentComponent(Self);
    PrepareClaimData.Name := 'PrepareClaimData';
    PrepareClaimData.Left := 38;
    PrepareClaimData.Top := 249;
    PrepareClaimData.Width := 561;
    PrepareClaimData.Height := 123;
    PrepareClaimData.HeightStyle := ssAuto;
    PrepareClaimData.WidthStyle := ssAuto;
    PrepareClaimData.BorderColor := clSilver;
    PrepareClaimData.ChildOrder := 13;
    PrepareClaimData.ElementFont := efCSS;
    PrepareClaimData.ElementHeaderClassName := 'thead-light';
    PrepareClaimData.ElementPosition := epIgnore;
    PrepareClaimData.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    PrepareClaimData.ColCount := 3;
    PrepareClaimData.RowCount := 2;
    JobsPlacedDateAdded.SetParentComponent(JobsPlaced);
    JobsPlacedDateAdded.Name := 'JobsPlacedDateAdded';
    JobsPlacedDateAdded.FieldName := 'DateAdded';
    JobsPlacedAddedBy.SetParentComponent(JobsPlaced);
    JobsPlacedAddedBy.Name := 'JobsPlacedAddedBy';
    JobsPlacedAddedBy.FieldName := 'AddedBy';
    JobsPlacedLastUpdatedBy.SetParentComponent(JobsPlaced);
    JobsPlacedLastUpdatedBy.Name := 'JobsPlacedLastUpdatedBy';
    JobsPlacedLastUpdatedBy.FieldName := 'LastUpdatedBy';
    JobsPlacedLastUpdated.SetParentComponent(JobsPlaced);
    JobsPlacedLastUpdated.Name := 'JobsPlacedLastUpdated';
    JobsPlacedLastUpdated.FieldName := 'LastUpdated';
    JobsPlacedJobCategory.SetParentComponent(JobsPlaced);
    JobsPlacedJobCategory.Name := 'JobsPlacedJobCategory';
    JobsPlacedJobCategory.FieldName := 'JobCategory';
    JobsPlacedJobCategory.Size := 8;
    JobsPlacedLastPolled.SetParentComponent(JobsPlaced);
    JobsPlacedLastPolled.Name := 'JobsPlacedLastPolled';
    JobsPlacedLastPolled.FieldName := 'LastPolled';
    JobsPlacedPollInterval.SetParentComponent(JobsPlaced);
    JobsPlacedPollInterval.Name := 'JobsPlacedPollInterval';
    JobsPlacedPollInterval.FieldName := 'PollInterval';
    JobsPlacedPollCount.SetParentComponent(JobsPlaced);
    JobsPlacedPollCount.Name := 'JobsPlacedPollCount';
    JobsPlacedPollCount.FieldName := 'PollCount';
    CloseTimer.Left := 32;
    CloseTimer.Top := 424;
    AuthOfficials.SetParentComponent(Self);
    AuthOfficials.Name := 'AuthOfficials';
    AuthOfficials.AfterOpen := AuthOfficialsAfterOpen;
    AuthOfficials.EntitySetName := 'User';
    AuthOfficials.Connection := MainData.DataConnection;
    AuthOfficials.Left := 456;
    AuthOfficials.Top := 64;
    AuthOfficialsId.SetParentComponent(AuthOfficials);
    AuthOfficialsId.Name := 'AuthOfficialsId';
    AuthOfficialsId.FieldName := 'Id';
    AuthOfficialsFirstName.SetParentComponent(AuthOfficials);
    AuthOfficialsFirstName.Name := 'AuthOfficialsFirstName';
    AuthOfficialsFirstName.FieldName := 'FirstName';
    AuthOfficialsFirstName.Size := 50;
    AuthOfficialsLastName.SetParentComponent(AuthOfficials);
    AuthOfficialsLastName.Name := 'AuthOfficialsLastName';
    AuthOfficialsLastName.FieldName := 'LastName';
    AuthOfficialsLastName.Size := 50;
    ConfigDataset.SetParentComponent(Self);
    ConfigDataset.Name := 'ConfigDataset';
    ConfigDataset.AfterOpen := ConfigDatasetAfterOpen;
    ConfigDataset.EntitySetName := 'GiftAidParams';
    ConfigDataset.Connection := MainData.DataConnection;
    ConfigDataset.Left := 544;
    ConfigDataset.Top := 64;
    ConfigDatasetId.SetParentComponent(ConfigDataset);
    ConfigDatasetId.Name := 'ConfigDatasetId';
    ConfigDatasetId.FieldName := 'Id';
    ConfigDatasetHMRCOfficial.SetParentComponent(ConfigDataset);
    ConfigDatasetHMRCOfficial.Name := 'ConfigDatasetHMRCOfficial';
    ConfigDatasetHMRCOfficial.FieldName := 'HMRCOfficial';
    ConfigDatasetCharityRef.SetParentComponent(ConfigDataset);
    ConfigDatasetCharityRef.Name := 'ConfigDatasetCharityRef';
    ConfigDatasetCharityRef.FieldName := 'CharityRef';
    ConfigDatasetCharityRef.Size := 50;
    ConfigDatasetCharityType.SetParentComponent(ConfigDataset);
    ConfigDatasetCharityType.Name := 'ConfigDatasetCharityType';
    ConfigDatasetCharityType.FieldName := 'CharityType';
    ConfigDatasetCharityType.Size := 15;
    ConfigDatasetGatewayId.SetParentComponent(ConfigDataset);
    ConfigDatasetGatewayId.Name := 'ConfigDatasetGatewayId';
    ConfigDatasetGatewayId.FieldName := 'GatewayId';
    ConfigDatasetGatewayId.Size := 50;
    ConfigDatasetGatewayPassword.SetParentComponent(ConfigDataset);
    ConfigDatasetGatewayPassword.Name := 'ConfigDatasetGatewayPassword';
    ConfigDatasetGatewayPassword.FieldName := 'GatewayPassword';
    ConfigDatasetGatewayPassword.Size := 64;
    ConfigDatasetRegulator.SetParentComponent(ConfigDataset);
    ConfigDatasetRegulator.Name := 'ConfigDatasetRegulator';
    ConfigDatasetRegulator.FieldName := 'Regulator';
    ConfigDatasetRegulator.Size := 5;
    ConfigDatasetRegulatorNumber.SetParentComponent(ConfigDataset);
    ConfigDatasetRegulatorNumber.Name := 'ConfigDatasetRegulatorNumber';
    ConfigDatasetRegulatorNumber.FieldName := 'RegulatorNumber';
    ConfigDatasetRegulatorNumber.Size := 50;
    ConfigDatasetEndOfYear.SetParentComponent(ConfigDataset);
    ConfigDatasetEndOfYear.Name := 'ConfigDatasetEndOfYear';
    ConfigDatasetEndOfYear.FieldName := 'EndOfYear';
    ConfigDatasetEndOfYear.Size := 5;
    ConfigDatasetOrganisationType.SetParentComponent(ConfigDataset);
    ConfigDatasetOrganisationType.Name := 'ConfigDatasetOrganisationType';
    ConfigDatasetOrganisationType.FieldName := 'OrganisationType';
    ConfigDatasetOrganisationType.Size := 16;
    ConfigDatasetOrganisationName.SetParentComponent(ConfigDataset);
    ConfigDatasetOrganisationName.Name := 'ConfigDatasetOrganisationName';
    ConfigDatasetOrganisationName.FieldName := 'OrganisationName';
    ConfigDatasetOrganisationName.Size := 250;
    ConfigDatasetSubmissionMethod.SetParentComponent(ConfigDataset);
    ConfigDatasetSubmissionMethod.Name := 'ConfigDatasetSubmissionMethod';
    ConfigDatasetSubmissionMethod.FieldName := 'SubmissionMethod';
    ConfigDatasetSubmissionMethod.Size := 4;
    GAUsers.SetParentComponent(Self);
    GAUsers.Name := 'GAUsers';
    GAUsers.Left := 8;
    GAUsers.Top := 16;
    InitialCheck.SetParentComponent(Self);
    InitialCheck.Name := 'InitialCheck';
    InitialCheck.Enabled := False;
    SetEvent(InitialCheck, Self, 'OnTimer', 'InitialCheckTimer');
    InitialCheck.Left := 576;
    InitialCheck.Top := 136;
    DisplayClaimDeclaration.SetParentComponent(Self);
    DisplayClaimDeclaration.Name := 'DisplayClaimDeclaration';
    DisplayClaimDeclaration.Enabled := False;
    SetEvent(DisplayClaimDeclaration, Self, 'OnTimer', 'DisplayClaimDeclarationTimer');
    DisplayClaimDeclaration.Left := 576;
    DisplayClaimDeclaration.Top := 264;
    ClaimDeclaration.SetParentComponent(Self);
    ClaimDeclaration.Name := 'ClaimDeclaration';
    ClaimDeclaration.AfterPost := ClaimDeclarationAfterPost;
    ClaimDeclaration.EntitySetName := 'ClaimDeclaration';
    ClaimDeclaration.Connection := MainData.DataConnection;
    ClaimDeclaration.Left := 472;
    ClaimDeclaration.Top := 136;
    ClaimDeclarationId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationId.Name := 'ClaimDeclarationId';
    ClaimDeclarationId.FieldName := 'Id';
    ClaimDeclarationDateAdded.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDateAdded.Name := 'ClaimDeclarationDateAdded';
    ClaimDeclarationDateAdded.FieldName := 'DateAdded';
    ClaimDeclarationAddedBy.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationAddedBy.Name := 'ClaimDeclarationAddedBy';
    ClaimDeclarationAddedBy.FieldName := 'AddedBy';
    ClaimDeclarationLastUpdatedBy.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdatedBy.Name := 'ClaimDeclarationLastUpdatedBy';
    ClaimDeclarationLastUpdatedBy.FieldName := 'LastUpdatedBy';
    ClaimDeclarationLastUpdated.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationLastUpdated.Name := 'ClaimDeclarationLastUpdated';
    ClaimDeclarationLastUpdated.FieldName := 'LastUpdated';
    ClaimDeclarationClaimId.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationClaimId.Name := 'ClaimDeclarationClaimId';
    ClaimDeclarationClaimId.FieldName := 'ClaimId';
    ClaimDeclarationDeclarationVersion.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationVersion.Name := 'ClaimDeclarationDeclarationVersion';
    ClaimDeclarationDeclarationVersion.FieldName := 'DeclarationVersion';
    ClaimDeclarationDeclarationHash.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationHash.Name := 'ClaimDeclarationDeclarationHash';
    ClaimDeclarationDeclarationHash.FieldName := 'DeclarationHash';
    ClaimDeclarationDeclarationHash.Size := 64;
    ClaimDeclarationDeclarationIssueDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationIssueDate.Name := 'ClaimDeclarationDeclarationIssueDate';
    ClaimDeclarationDeclarationIssueDate.FieldName := 'DeclarationIssueDate';
    ClaimDeclarationDeclarationExpiryDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationExpiryDate.Name := 'ClaimDeclarationDeclarationExpiryDate';
    ClaimDeclarationDeclarationExpiryDate.FieldName := 'DeclarationExpiryDate';
    ClaimDeclarationDeclarationSignedDate.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedDate.Name := 'ClaimDeclarationDeclarationSignedDate';
    ClaimDeclarationDeclarationSignedDate.FieldName := 'DeclarationSignedDate';
    ClaimDeclarationDeclarationSignedByUser.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSignedByUser.Name := 'ClaimDeclarationDeclarationSignedByUser';
    ClaimDeclarationDeclarationSignedByUser.FieldName := 'DeclarationSignedByUser';
    ClaimDeclarationDeclarationByName.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationByName.Name := 'ClaimDeclarationDeclarationByName';
    ClaimDeclarationDeclarationByName.FieldName := 'DeclarationByName';
    ClaimDeclarationDeclarationByName.Size := 100;
    ClaimDeclarationDeclarationSigningChannel.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationSigningChannel.Name := 'ClaimDeclarationDeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.FieldName := 'DeclarationSigningChannel';
    ClaimDeclarationDeclarationSigningChannel.Size := 10;
    ClaimDeclarationDeclarationStatus.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationDeclarationStatus.Name := 'ClaimDeclarationDeclarationStatus';
    ClaimDeclarationDeclarationStatus.FieldName := 'DeclarationStatus';
    ClaimDeclarationDeclarationStatus.Size := 8;
    ClaimDeclarationSignedDeclarationText.SetParentComponent(ClaimDeclaration);
    ClaimDeclarationSignedDeclarationText.Name := 'ClaimDeclarationSignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.FieldName := 'SignedDeclarationText';
    ClaimDeclarationSignedDeclarationText.Size := 2048;
    PrepareClaimTimer.SetParentComponent(Self);
    PrepareClaimTimer.Name := 'PrepareClaimTimer';
    PrepareClaimTimer.Enabled := False;
    SetEvent(PrepareClaimTimer, Self, 'OnTimer', 'PrepareClaimTimerTimer');
    PrepareClaimTimer.Left := 576;
    PrepareClaimTimer.Top := 416;
  finally
    JobsPlacedTable.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    PlaceJobButton.AfterLoadDFMValues;
    OutputOption.AfterLoadDFMValues;
    JobVisibility.AfterLoadDFMValues;
    WaitMessage.AfterLoadDFMValues;
    JobRunType.AfterLoadDFMValues;
    AgreeCheckBox.AfterLoadDFMValues;
    AuthorisedOfficial.AfterLoadDFMValues;
    ErrorHandling.AfterLoadDFMValues;
    HMRCPassword.AfterLoadDFMValues;
    UserClaimRef.AfterLoadDFMValues;
    PrepareClaimDataXXX.AfterLoadDFMValues;
    ConfirmClaimCheckBox.AfterLoadDFMValues;
    OldestDateParameter.AfterLoadDFMValues;
    NewestDateParameter.AfterLoadDFMValues;
    ImportFiles.AfterLoadDFMValues;
    PrepareWaitMessage.AfterLoadDFMValues;
    CancelPrepareClaimButton.AfterLoadDFMValues;
    PrepareClaimButton.AfterLoadDFMValues;
    DeclarationTextMemo.AfterLoadDFMValues;
    PrepareClaimData.AfterLoadDFMValues;
    JobsPlaced.AfterLoadDFMValues;
    JobsPlacedDateAdded.AfterLoadDFMValues;
    JobsPlacedAddedBy.AfterLoadDFMValues;
    JobsPlacedLastUpdatedBy.AfterLoadDFMValues;
    JobsPlacedLastUpdated.AfterLoadDFMValues;
    JobsPlacedJobCategory.AfterLoadDFMValues;
    JobsPlacedLastPolled.AfterLoadDFMValues;
    JobsPlacedPollInterval.AfterLoadDFMValues;
    JobsPlacedPollCount.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
    AuthOfficials.AfterLoadDFMValues;
    AuthOfficialsId.AfterLoadDFMValues;
    AuthOfficialsFirstName.AfterLoadDFMValues;
    AuthOfficialsLastName.AfterLoadDFMValues;
    ConfigDataset.AfterLoadDFMValues;
    ConfigDatasetId.AfterLoadDFMValues;
    ConfigDatasetHMRCOfficial.AfterLoadDFMValues;
    ConfigDatasetCharityRef.AfterLoadDFMValues;
    ConfigDatasetCharityType.AfterLoadDFMValues;
    ConfigDatasetGatewayId.AfterLoadDFMValues;
    ConfigDatasetGatewayPassword.AfterLoadDFMValues;
    ConfigDatasetRegulator.AfterLoadDFMValues;
    ConfigDatasetRegulatorNumber.AfterLoadDFMValues;
    ConfigDatasetEndOfYear.AfterLoadDFMValues;
    ConfigDatasetOrganisationType.AfterLoadDFMValues;
    ConfigDatasetOrganisationName.AfterLoadDFMValues;
    ConfigDatasetSubmissionMethod.AfterLoadDFMValues;
    GAUsers.AfterLoadDFMValues;
    InitialCheck.AfterLoadDFMValues;
    DisplayClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclaration.AfterLoadDFMValues;
    ClaimDeclarationId.AfterLoadDFMValues;
    ClaimDeclarationDateAdded.AfterLoadDFMValues;
    ClaimDeclarationAddedBy.AfterLoadDFMValues;
    ClaimDeclarationLastUpdatedBy.AfterLoadDFMValues;
    ClaimDeclarationLastUpdated.AfterLoadDFMValues;
    ClaimDeclarationClaimId.AfterLoadDFMValues;
    ClaimDeclarationDeclarationVersion.AfterLoadDFMValues;
    ClaimDeclarationDeclarationHash.AfterLoadDFMValues;
    ClaimDeclarationDeclarationIssueDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationExpiryDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedDate.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSignedByUser.AfterLoadDFMValues;
    ClaimDeclarationDeclarationByName.AfterLoadDFMValues;
    ClaimDeclarationDeclarationSigningChannel.AfterLoadDFMValues;
    ClaimDeclarationDeclarationStatus.AfterLoadDFMValues;
    ClaimDeclarationSignedDeclarationText.AfterLoadDFMValues;
    PrepareClaimTimer.AfterLoadDFMValues;
  end;
end;

end.
